import useUserMetaState from 'modules/queries/account/user/stateData/useUserMetaState';

/**
 * Whether Nutanix VMs are nested under their VPC in the servers list. Persisted per user and shared by every caller through the meta state
 * query cache.
 */
const useServersNestingPreference = () =>
	useUserMetaState<boolean>('serversNestingPreference', true);

export default useServersNestingPreference;
